// Copyright 2018 The MathWorks, Inc.

define([
    "dojo/_base/declare",
    "dijit/_Container",
    "dijit/_TemplatedMixin",
    "dijit/_WidgetBase",
    "dijit/registry",
    "MW/toolstrip/widgets/_WidgetMixin",
    "MW/uiframework/FocusManager",
    "dojo/text!./templates/StatusBar.html"
], function (declare, _Container, _TemplatedMixin, _WidgetBase, registry, _WidgetMixin, FocusManager, template) {
    return declare([_WidgetBase, _Container, _TemplatedMixin, _WidgetMixin], {

        templateString: template,

        postCreate: function () {
            FocusManager.refuseFocus(this.domNode);
        },

        addChild: function(widget) {
            // Ignore any index argument supplied.  Instead honor the widget's index property if it has one.
            arguments[1] = undefined;
            this.inherited(arguments);
            if (!this._blockPlacement) {
                this._placeChild(widget, widget.index, widget.region);
            }
        },

        addToLeft: function(widget, index) {
            this._addWithoutPlacing(widget);
            this._placeChild(widget, index, "left");
        },

        addToRight: function(widget, index) {
            this._addWithoutPlacing(widget);
            this._placeChild(widget, index, "right");
        },

        _addWithoutPlacing: function(widget) {
            this._blockPlacement = true;
            this.addChild(widget);
            this._blockPlacement = false;
        },

        _placeChild: function(widget, index, region) {
            if (region === "right") {
                widget.placeAt(this.rightNode, index > 0 ? index : "first");
            } else {
                widget.placeAt(this.leftNode, index);
            }
        },

        removeChild: function(widget, index, region) {
            if (!widget) {
                if (index === undefined) {
                    index = region === "right" ? 0 : this.leftNode.children.length - 1;
                }
                widget = this._getChildAt(region, index);
            }
            this.inherited(arguments);

        },

        removeFromLeft: function(index) {
            this.removeChild(null, index, "left");
        },

        removeFromRight: function(index) {
            this.removeChild(null, index, "right");
        },

        _getChildAt: function(region, index) {
            var parent = region === "right" ? this.rightNode : this.leftNode;
            var child;
            if (parent.children.length > index) {
                child = registry.byNode(parent.children[index]);
            }
            return child;
        }
    });
});